// useClickOutside.js
import useClickOutside from '../../../CustomHooks/useClickOutside';

// Dropdown.jsx
import React, { useCallback, useState } from 'react';
import { FaCaretDown } from 'react-icons/fa6';
import classes from './CustomDropdown.module.css';
const CustomDropdown = ({ options = [], value = null, onChange = (value) => {}, setter }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Use callback to memoize the close function
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  // Use the click outside hook
  const dropdownRef = useClickOutside(handleClose);

  const handleSelect = (option) => {
    setter(option);
    setIsOpen(false);
    onChange(option);
  };

  return (
    <div className={classes.dropdownContainer} ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)} className={classes.dropdownButton}>
        <span>{value?.label}</span>
        <FaCaretDown
          size={12}
          className={`${classes.chevronIcon} ${isOpen ? classes.chevronIconOpen : ''}`}
        />
      </button>

      {isOpen && (
        <div className={classes.dropdownMenu}>
          <ul className={classes.optionsList}>
            {options.map((option) => (
              <li
                key={option}
                onClick={() => handleSelect(option)}
                className={`${classes.optionItem} ${
                  value === option ? classes.optionItemSelected : ''
                }`}>
                {option?.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
